import { render, staticRenderFns } from "./departure.vue?vue&type=template&id=2df86fb0&scoped=true"
import script from "./departure.vue?vue&type=script&lang=js"
export * from "./departure.vue?vue&type=script&lang=js"
import style0 from "./departure.vue?vue&type=style&index=0&id=2df86fb0&prod&lang=css"
import style1 from "./departure.vue?vue&type=style&index=1&id=2df86fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df86fb0",
  null
  
)

export default component.exports